module.exports = __webpack_public_path__ + "3110d88159352c4d6284c4c730093894.svg";